import React, {Component} from 'react'
import _ from 'lodash'
import {FlexboxGrid} from 'rsuite'
import Moment from 'react-moment'
import {StyledButton, StyledSummaryContainer} from '../styled/StyledQuestionComponents'
import LoadingOverlay from './LoadingOverlay'


class PreviousTriesSummary extends Component {
    constructor(props) {
        super(props) 
    }

    componentDidUpdate(prevProps){
        const {previousTriesDTO} = this.props
        previousTriesDTO &&
            prevProps.previousTriesDTO !== previousTriesDTO &&
                this.props.loading()
    }

    render() { 
        const {previousTriesDTO} = this.props

        const sortedPreviousTriesDTO = _.isEmpty(previousTriesDTO) ? [] : _.sortBy(previousTriesDTO, s => -s.submissionDate)
        const maxCode = _.max(sortedPreviousTriesDTO.map(t => t.code))
        const triesInfoLine = sortedPreviousTriesDTO && sortedPreviousTriesDTO.map((item, key) => {
            const submisionDate = item.submissionDate
            const timeSpent = item.timeSpent
            return (
                <FlexboxGrid key={key} justify='space-around'>
                    <FlexboxGrid.Item className={'submision'} colspan={3}>
                        <Moment subtract={{minutes: timeSpent}} format="DD/MM/YYYY HH:mm">{submisionDate}</Moment>
                    </FlexboxGrid.Item>

                    <FlexboxGrid.Item colspan={3}>
                        <Moment format="DD/MM/YYYY HH:mm">{submisionDate}</Moment>
                    </FlexboxGrid.Item>

                    {
                        this.props.hasTime &&
                        <FlexboxGrid.Item colspan={3}>
                            {
                                item.timeSpent === null ?
                                    '--'
                                    :
                                    item.timeSpent + ' min.'
                            }

                        </FlexboxGrid.Item>
                    }

                    <FlexboxGrid.Item className={'score'} colspan={3}>
                        <span> {item.grade}</span>/ {item.value}pts
                    </FlexboxGrid.Item>
                    <FlexboxGrid.Item className={'score'} colspan={4}>
                        {
                            maxCode === item.code &&
                            <StyledButton
                                color={'blue'}
                                appearance="defaut"
                                onClick={() => this.props.reviewOn(true)}
                            >
                                Revisar Simulado
                            </StyledButton>
                        }
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            )
        })
        return (
            <div>
                <StyledSummaryContainer className={'previous'}>
                    <FlexboxGrid className={'previous-tries-header'} justify='space-around'>
                        <FlexboxGrid.Item colspan={3}>
                            Início:
                        </FlexboxGrid.Item>

                        <FlexboxGrid.Item colspan={3}>
                            Concluído:
                        </FlexboxGrid.Item>

                        {
                            this.props.hasTime &&
                            <FlexboxGrid.Item colspan={3}>
                                Tempo empregado:
                            </FlexboxGrid.Item>
                        }

                        <FlexboxGrid.Item colspan={3}>
                            Nota:
                        </FlexboxGrid.Item>
                        <FlexboxGrid.Item colspan={4}>

                        </FlexboxGrid.Item>

                    </FlexboxGrid>
                    <div className={'previous-tries'}>
                        <div className={'card'}>
                            {triesInfoLine}
                        </div>
                    </div>
             
                 
                 
                </StyledSummaryContainer>
              
               
            </div>
        )
    }
}

export default PreviousTriesSummary



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/PreviousTriesSummary.js